
import { onBeforeUnmount, onMounted } from 'vue'
import { createScript, removeScript } from '@/utils/script'
export default {
  props: {
    url: {
      type: String,
      default: location.href
    }
  },
  setup() {
    const id = 'facebook-jssdk'
    const facebookUrl =
      'https://connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v9.0'
    onMounted(() => {
      createScript(id, facebookUrl)
    })
    onBeforeUnmount(() => {
      removeScript(id)
    })
  }
}
